import AddUserModalInputText from './component'

export default AddUserModalInputText
